<template>
	<div
		class="g-block-title-thick-underline g-block-title-padding"
		:class="{
			'g-block-title-thick-underline--edit': editable,
			'is-active': editable && active,
			'g-block-title-thick-underline--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-thick-underline__wrap">
			<RichTextEditable
				v-if="editable"
				class="g-block-title-thick-underline__text"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-thick-underline__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
			<span class="g-block-title-thick-underline__line" :style="{ background: themeColor }"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleThickUnderline',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-thick-underline {
		.title-block-edit-shell();
		text-align: center;
	}

	.g-block-title-thick-underline__wrap {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		max-width: 100%;
	}

	.g-block-title-thick-underline__text {
		font-size: 22px;
		font-weight: 700;
		line-height: 1.3;
		text-align: center;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; text-align: center; }
	}

	.g-block-title-thick-underline__line {
		width: 100%;
		height: 4px;
		margin-top: 8px;
		border-radius: 1px;
	}

	.g-block-title-thick-underline--h5 {
		.g-block-title-thick-underline__text { font-size: 0.44rem; }
		.g-block-title-thick-underline__line { height: 0.08rem; margin-top: 0.16rem; }
	}
</style>
